const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = 60 * SECONDS_IN_MINUTE;
const SECONDS_IN_DAY = 24 * SECONDS_IN_HOUR;

const secondsToIsoDuration = (rawSeconds?: number | null): string | null => {
  if (typeof rawSeconds !== 'number' || !isFinite(rawSeconds)) {
    return null;
  }

  const total = Math.floor(rawSeconds);

  if (total <= 0 || total > SECONDS_IN_DAY) {
    return null;
  }

  const hours = Math.floor(total / SECONDS_IN_HOUR);
  const minutes = Math.floor((total % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
  const seconds = total % SECONDS_IN_MINUTE;

  return `PT${hours ? `${hours}H` : ''}${minutes ? `${minutes}M` : ''}${
    seconds ? `${seconds}S` : ''
  }`;
};

export default secondsToIsoDuration;
